import { React, useEffect, useReducer, useState,  } from 'react';

import { Row, Col, Typography, Space, Table, Empty, message, Spin, Popover, Avatar, Card, Button, Modal, Form,Input } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { InfoOutlined, EditOutlined, DeleteOutlined,ClusterOutlined,PlusOutlined} from '@ant-design/icons';
import { MODELTYPE_LIST, MODELTYPE_LIST_SUCCESS, MODELTYPE_LIST_ERROR, ADD_MODELTYPE, ADD_MODELTYPE_SUCCESS, ADD_MODELTYPE_ERROR, EDIT_MODELTYPE, EDIT_MODELTYPE_SUCCESS, EDIT_MODELTYPE_ERROR, MODELTYPE_DETAILS, MODELTYPE_DETAILS_SUCCESS, MODELTYPE_DETAILS_ERROR, DELETE_MODELTYPE, DELETE_MODELTYPE_SUCCESS, DELETE_MODELTYPE_ERROR } from './constants';
import axios from 'axios';
import ModelTypeDataReducer from './reducer';
import { useNavigate } from 'react-router-dom';

// import englan from '../../english.json';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useFormik } from 'formik';
import { useAuth } from '../../Context';

const { Title } = Typography;


export default function ModelType() {
    
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = { modeltype : [], details: null, loading: false, error: false};
	const [data, dispatch] = useReducer(ModelTypeDataReducer, initalState);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const [openAddDrawer, setOpenAddDrawer] = useState(false);
	const [openEditDrawer, setOpenEditDrawer] = useState(false);
	const [showDeleteModalTypeModal, setshowDeleteModalTypeModal] = useState(false);
	useAuth();
	const navigate = useNavigate();
	const [form] = Form.useForm();	
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const admin_roles = ['superadmin','admin'];
	const active = false;
	const columns = [

		
		{
			title: `${langdata && langdata.Name ? langdata.Name:'Name'}`,
			dataIndex: 'name',
			key: 'name',
			
		},
		{
			title: `${langdata && langdata.Dimension ? langdata.Dimension:'Dimension'}`,
			dataIndex: 'dimension',
			key: 'dimension',
			
		},
		{
			title: `${langdata && langdata.posititon ? langdata.posititon:'Position'}`,
			dataIndex: 'position',
			key: 'position',
			
		}
	];

	if(admin_roles.includes(permission)){
		columns.push({
			title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
			align:'center',
			render:(_,record) => (
				<>
					<Space style={{justifyContent:'center',display:'flex'}} size="middle">
						<a title={langdata && langdata.Edit ? langdata.Edit:'Edit'}  onClick={()=>loadeditmodeltypedatahandler(record)}><EditOutlined/></a>
						<a disabled style={{display : active == true ? '' : 'none'}} title={langdata && langdata.Delete ? langdata.Delete :'Delete'} onClick={()=>loaddeletemodeltypedatahandler(record)}><DeleteOutlined /></a>
					</Space>
				</>
			)
		});
	}

	

	
	useEffect(() => {
		if(featuresModule.modelTypeEnabled == false) {
			navigate('/dashboard');
		}
		if(!authtoken){
			navigate('/');
		}
	
	},[authtoken]);

	useEffect(() => {
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4025);

	}, []);
	
	useEffect(() => {
		loadModeltypes();
	}, []);


	const loadModeltypes = () => {
		dispatch({ type : MODELTYPE_LIST});
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/modeltype?$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
		};
    
		axios.request(config)
			.then((response) => {

				if (response.status === 200) {
					dispatch({ type : MODELTYPE_LIST_SUCCESS, payload : response.data});
				}else {
					dispatch({ type : MODELTYPE_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : MODELTYPE_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});

	};
	
	
	



	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{langdata && langdata.ModelTypeInfoContent ? langdata.ModelTypeInfoContent :'This module defines the spatial index range of fiber-optic sensing data (DTS/DAS) to be extracted and processed around a detected anomaly location.'}</p>
		</Card>
	);


	const showAddDrawer = () => {

		setOpenAddDrawer(true);
	};

	const onCloseAddDrawer = () => {
		setOpenAddDrawer(false);
		addmodeltype.resetForm();
		form.resetFields();
	};

	const showEditDrawer = () => {
		
		setOpenEditDrawer(true);
		
	};

	const openDeleteAssetsModal = () => {
		setshowDeleteModalTypeModal(true);
	};

	const loaddeletemodeltypedatahandler = (record) =>{
		loadMessageDetails(record);
		openDeleteAssetsModal();

	};

	const loadeditmodeltypedatahandler = (record) =>{
		loadMessageDetails(record);
		showEditDrawer();

	};
	

	const addmodeltype = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  '',
			position : null,
			dimension : null,
		},
		onSubmit: (values) => {					
			if (!values.name || values.name == null || values.name === '') {
				Modal.warning({ title: langdata && langdata.PleaseEnterName ? langdata.PleaseEnterName : 'Please enter name' });
				return false;
			}
	
			dispatch({type:ADD_MODELTYPE});
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/modeltype`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					name : values.name,
					dimension : values.dimension,
					position : values.position
				}
			};
	
			axios
				.request(config)	
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch( { type: ADD_MODELTYPE_SUCCESS, payload: response.data.data });
						Modal.success({ title: `${langdata && langdata.modaltypeaddedSuccessfully ? langdata.modaltypeaddedSuccessfully :'Modal Type added Successfully'}` });
						loadModeltypes();
						form.resetFields();
						addmodeltype.resetForm();
						setOpenAddDrawer(false);
	
						
					}
				})
				.catch((error) => {
					console.log(error);
						
					dispatch({ type: ADD_MODELTYPE_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
	});


	const editmodeltype = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  data?.details?.name || '',
			dimension : data?.details?.dimension || null,
			position : data?.details?.position || null
		},
		onSubmit: (values) => {	
		
			dispatch({type:EDIT_MODELTYPE});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/modeltype/${data?.details?.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					name : values.name,
					dimension : values.dimension,
					position : values.position
				}
			};
 
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200) {
						dispatch( { type: EDIT_MODELTYPE_SUCCESS});
						Modal.success({ title: `${langdata && langdata.modaltypeupdatedSuccessfully ? langdata.modaltypeupdatedSuccessfully :'Modal Type updated Successfully'}` });
						editmodeltype.resetForm();
						form.resetFields();
						setOpenEditDrawer(false);
						loadModeltypes();
					}
				})
				.catch((error) => {
					console.log(error);
						
					dispatch({ type: EDIT_MODELTYPE_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
		
	});

	const loadMessageDetails = ((record) => {
		
		dispatch( { type: MODELTYPE_DETAILS });
			
		if (!record) {
			dispatch({ type: MODELTYPE_DETAILS_ERROR });
		} else {
			dispatch({ type: MODELTYPE_DETAILS_SUCCESS, payload: record });
		
		}
		
	});

	const handleModalCancel = () => {
		form.resetFields();
		editmodeltype.resetForm();
		setOpenEditDrawer(false);

	};
	const closeDeleteBatchModal = () => {
		setshowDeleteModalTypeModal(false);
	};

	const deleteMessage = () => {
		const id = parseInt(data?.details?.id);
			
		dispatch({ type: DELETE_MODELTYPE });
		
		let config = {
			method: 'delete',   
			maxBodyLength: Infinity,
			url: `${api}/modeltype/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
		
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_MODELTYPE_SUCCESS, payload: response});
					setshowDeleteModalTypeModal(false);        
					loadModeltypes();
				} else {
					dispatch({type:DELETE_MODELTYPE_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_MODELTYPE_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	


	return (
		<>
			<Content>
				
				<Row 
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >

					<Col span={8}>
						<Row>

							<Space>
								<ClusterOutlined style={{fontSize:'30px'}}/>
							</Space>
							<Space>&nbsp;&nbsp;</Space>
					
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.ModelType ? langdata.ModelType:'Model Type'}</Title>
						</Row>
					</Col>
					<Col span={16}>
						<Row justify="end">
							<Col>
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={showAddDrawer}><PlusOutlined />
										{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
		
								<Space>&nbsp;&nbsp;</Space>
								<Space>
									<Typography>
										<Popover title={langdata && langdata.ModelType ? langdata.ModelType:'Model Type'}  content={infoContent} trigger="click">
											<Avatar size="small"><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>
				
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					marginTop:'0px',
					background: '#FFFFFF',
					alignItems:'center'
				}}>
					<Col span={24}>
						{data?.modeltype?.length > 0 ?
							<Table 
								scroll={{
									x: 900,
								}}
								columns={columns} dataSource={data.modeltype} 
								onChange = { loadModeltypes }
								
								
								onRow={() => {
									return {
										onClick: () => { 
											// loadMessageDetails(record);
										}
									};
								}} />
							:
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						}
					</Col>
				</Row>

				<Modal
					title={ langdata&&langdata.AddModeltype ? langdata.AddModeltype : 'Add Model Type' }
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={openAddDrawer}
					onOk={{onCloseAddDrawer}}
					onCancel={onCloseAddDrawer}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={onCloseAddDrawer}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							<Button type="primary" onClick={addmodeltype.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button>
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={addmodeltype.handleSubmit} form={form} >
									
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="name" label={langdata&&langdata.Name?langdata.Name:'Name'} rules={[{ required: true, message: langdata && langdata.PleaseEnterName ? langdata.PleaseEnterName : 'Please enter name' }]} >
									<Input  name="name" onChange={addmodeltype.handleChange} placeholder={langdata && langdata.PleaseEnterName ? langdata.PleaseEnterName : 'Please enter name' } />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="dimension" label={langdata&&langdata.Dimension?langdata.Dimension:'Dimension'} rules={[{ required: false, message: langdata && langdata.PleaseEnterTheDimension ? langdata.PleaseEnterTheDimension : 'Please enter the dimension' }]} >
									<Input min={0} type='number' name="dimension" onChange={addmodeltype.handleChange} placeholder={langdata && langdata.PleaseEnterTheDimension ? langdata.PleaseEnterTheDimension : 'Please enter the dimension' } />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="position" label={langdata&&langdata.posititon?langdata.posititon:'Posititon'} rules={[{ required: false, message: langdata && langdata.PleaseEnterThePosition ? langdata.PleaseEnterThePosition : 'Please enter the position' }]} >
									<Input  min={0} type='number'  name="position" onChange={addmodeltype.handleChange} placeholder={langdata && langdata.PleaseEnterThePosition ? langdata.PleaseEnterThePosition : 'Please enter the position' } />
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>


				<Modal
					title={langdata && langdata.EditModeltype ? langdata.EditModeltype:'Edit Model Type'}
					width={800}	
					centered
					destroyOnClose={true}
					maskClosable={false}
					onOk={editmodeltype.handleSubmit}
					onCancel={handleModalCancel}
					open={openEditDrawer}
					styles={{
						body: {
						},
					}}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={handleModalCancel}>
								{langdata && langdata.CANCEL ? langdata.CANCEL:'CANCEL'}
							</Button>
							<Button onClick={editmodeltype.handleSubmit} type="primary">
								{langdata && langdata.SAVE ? langdata.SAVE:'SAVE'}
							</Button>
						</Space>
					]}
				>
					<Form onSubmit={editmodeltype.handleSubmit} layout="vertical"
						form={form} 
						// onValuesChange={handleUpdateFormValuesChange}
					>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Name ? langdata.Name:'Name'} rules={[{ required: false, message: `${langdata && langdata.pleaseEntername ? langdata.PleaseEnterName:'please enter name'}` }]}>
									<Input  name="name" disabled  value={editmodeltype.values.name} onChange={editmodeltype.handleChange} defaultValue={editmodeltype.values.name}   />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Dimension ? langdata.Dimension:'Dimension'} rules={[{ required: false, message: `${langdata && langdata.pleaseEntername ? langdata.PleaseEnterName:'please enter name'}` }]}>
									<Input min={0}  type='number' name="dimension"   value={editmodeltype.values.dimension} onChange={editmodeltype.handleChange} defaultValue={editmodeltype.values.dimension}   />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.posititon ? langdata.posititon:'posititon'} rules={[{ required: false, message: `${langdata && langdata.pleaseEntername ? langdata.PleaseEnterName:'please enter name'}` }]}>
									<Input min={0} type='number' name="position"   value={editmodeltype.values.position} onChange={editmodeltype.handleChange} defaultValue={editmodeltype.values.position}   />
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>



				<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteModalTypeModal} onOk={deleteMessage} onCancel={closeDeleteBatchModal}>
					<Row style={{
						marginTop: '10px',
						marginBottom: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={1}>
							<DeleteOutlined  style={{ fontSize: '14px'}}/>
						</Col>
						<Col span={23}> { langdata && langdata.AreYouSureYouWantToDeleteThisModelType ? langdata.AreYouSureYouWantToDeleteThisModelType : 'Are you sure you want to delete this model type' }</Col>
					</Row>
				</Modal>
											
			</Content>
			

			<Spin spinning={data.loading} fullscreen />
		</>
	);
}